import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarItem, useToast, Button } from '@kinesis/bungle';
import { useIsEditor } from '@/hooks/use-is-editor';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNewPathwayMutation } from '@/api/pathways';
import { pathwayPath } from '@/links';

// The Pathways list toolbar: click-to-create (a default name, renamed on
// the detail page — the toolbar-create idiom).
const ToolbarPathways = () => {
  const [newPathway, { isLoading: isCreating }] = useNewPathwayMutation();
  const navigate = useNavigate();
  const inventoryId = useInventoryId();
  const toast = useToast('globalTop');
  const isEditor = useIsEditor();

  const onCreatePathway = useCallback(async () => {
    try {
      const data = await newPathway({
        inventoryId,
        name: 'New pathway',
      }).unwrap();
      navigate(pathwayPath(inventoryId, data.id));
    } catch (e) {
      toast('Could not create pathway.', { variant: 'error' });
    }
  }, [newPathway, inventoryId, navigate, toast]);

  return isEditor ? (
    <ToolbarItem>
      <Button onClick={onCreatePathway} variant='primary' loading={isCreating}>
        New pathway
      </Button>
    </ToolbarItem>
  ) : null;
};

export { ToolbarPathways };
